/* The Arch House — small, dependency-free behaviours.
   1. header turns solid once the hero has scrolled past
   2. mobile drawer
   3. hero / cta video: pick a size, honour reduced motion and data-saver, pause control
   ?sheet=1 is capture mode: fixed hero height, poster instead of autoplay (used for screenshots). */
(function () {
  "use strict";

  if (/[?&]sheet=1/.test(window.location.search)) document.documentElement.setAttribute("data-sheet", "");

  var inSheet = document.documentElement.hasAttribute("data-sheet");
  var reduceMotion = inSheet || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var saveData = Boolean(navigator.connection && navigator.connection.saveData);

  /* ---- header ---- */
  var header = document.querySelector("[data-header]");
  var hero = document.querySelector(".hero");
  function updateHeader() {
    if (!header) return;
    // pages without a video hero (The House, Spaces, Seasonal, FAQ, Pricing, Book) get the solid header from the first pixel
    var threshold = hero ? Math.max(hero.offsetHeight - 96, 80) : 40;
    header.classList.toggle("is-solid", !hero || window.scrollY > threshold);
  }
  updateHeader();
  window.addEventListener("scroll", updateHeader, { passive: true });
  window.addEventListener("resize", updateHeader);

  /* ---- drawer ---- */
  var drawer = document.querySelector("[data-drawer]");
  var openButton = document.querySelector("[data-menu-open]");
  var closeButton = document.querySelector("[data-menu-close]");
  var lastFocus = null;

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute("data-open", open ? "true" : "false");
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    if (openButton) openButton.setAttribute("aria-expanded", open ? "true" : "false");
    document.documentElement.style.overflow = open ? "hidden" : "";
    if (open) {
      lastFocus = document.activeElement;
      var first = drawer.querySelector("a, button");
      if (first) first.focus();
    } else if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
  }

  if (openButton) {
    openButton.addEventListener("click", function (event) { event.preventDefault(); setDrawer(true); });
  }
  if (closeButton) {
    closeButton.addEventListener("click", function (event) { event.preventDefault(); setDrawer(false); });
  }
  if (drawer) {
    drawer.addEventListener("click", function (event) {
      if (event.target.closest("a")) setDrawer(false);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.getAttribute("data-open") === "true") setDrawer(false);
    });
  }


  /* ---- review switcher: only on review links from the options sheet ---- */
  if (/[?&]review=1/.test(window.location.search) && !inSheet) {
    var here = window.location.pathname.split("/").pop() || "index.html";
    var pages = [
      ["index.html", "1 Cinematic · chosen"],
      ["2-editorial.html", "2 Editorial"],
      ["3-gallery.html", "3 Gallery"]
    ];
    var strip = document.createElement("nav");
    strip.className = "review-strip";
    strip.setAttribute("aria-label", "Compare homepage directions");
    pages.forEach(function (page) {
      var link = document.createElement("a");
      link.href = page[0] + "?review=1";
      link.textContent = page[1];
      if (page[0] === here) link.setAttribute("aria-current", "page");
      strip.appendChild(link);
    });
    var sep = document.createElement("span");
    sep.className = "sep";
    strip.appendChild(sep);
    var sheet = document.createElement("a");
    sheet.href = "../options/index.html";
    sheet.textContent = "Options sheet";
    strip.appendChild(sheet);
    document.body.appendChild(strip);
  }

  /* ---- video ---- */
  var videos = document.querySelectorAll("[data-video]");

  Array.prototype.forEach.call(videos, function (video) {
    var large = video.getAttribute("data-src-large");
    var small = video.getAttribute("data-src-small") || large;
    var narrow = window.matchMedia("(max-width: 60rem)").matches;
    var section = video.closest("section");
    var toggle = section ? section.querySelector("[data-video-toggle]") : null;

    function isPlaying() { return !video.paused && !video.ended; }

    function setLabel() {
      if (!toggle) return;
      var playing = isPlaying();
      toggle.textContent = playing ? "Pause video" : "Play video";
      toggle.setAttribute("aria-pressed", playing ? "false" : "true");
    }

    // the poster is the frame at data-start seconds, so the video begins there (a media fragment) and the hand-over is seamless
    var start = parseFloat(video.getAttribute("data-start") || "0") || 0;

    function tryPlay() {
      if (!video.getAttribute("src")) video.src = (narrow ? small : large) + (start > 0 ? "#t=" + start : "");
      video.muted = true;
      var attempt = video.play();
      if (attempt && typeof attempt.catch === "function") attempt.catch(function () { setLabel(); });
    }

    video.addEventListener("playing", function () { video.classList.add("is-playing"); setLabel(); });
    video.addEventListener("play", setLabel);
    video.addEventListener("pause", setLabel);

    if (reduceMotion || saveData) {
      // leave the poster frame in place; the visitor can opt in with the control
      video.removeAttribute("autoplay");
      video.preload = "none";
    } else {
      tryPlay();
    }
    setLabel();

    if (toggle) {
      toggle.addEventListener("click", function () {
        if (isPlaying()) video.pause(); else tryPlay();
      });
    }
  });
})();
